<template>
    <div class="training-filter-tool">
        <h1 class="title">
            <span class="material-icons"> psychology </span>
            {{ $t("chatbotv2.training") }}
        </h1>
        <section class="search">
            <span class="material-icons"> search </span>
            <input
                class="search-input"
                type="text"
                :placeholder="$t('chatbotv2.searchUserQuery')"
                maxlength="256"
                :value="cloneFilters.query"
                @change="handleQueryChange"
            />
        </section>
        <section class="tabs">
            <div class="tab" :class="{ active: !cloneFilters.ignored }" @click="() => changeIgnoreFilterStatus(false)">
                <span class="material-icons"> record_voice_over </span>
                <div class="title">
                    {{ $t("chatbotv2.unmatchedPhrases") }}
                    <div class="count">{{ rowCount }}</div>
                </div>
            </div>
            <div class="tab" :class="{ active: cloneFilters.ignored }" @click="() => changeIgnoreFilterStatus(true)">
                <span class="material-icons"> visibility_off </span>
                <div class="title">
                    {{ $t("chatbotv2.ignored") }}
                    <div class="count">{{ rowCount }}</div>
                </div>
            </div>
        </section>
        <section class="stories">
            <h6>{{ $t("chatbotv2.Scenario") }}</h6>
            <a-select
                :value="cloneFilters.storyId"
                @select="handleSelectStory"
                class="select-story"
                :placeholder="$t('chatbotv2.selectAStory')"
                :filter-option="false"
            >
                <a-select-option
                    :value="story._id"
                    v-for="story of stories"
                    :key="story._id"
                    @click="() => storySelectOptionClick(story._id)"
                >
                    <span class="blockTypeText">{{ story.title }}</span>
                </a-select-option>
            </a-select>
        </section>
        <section class="period">
            <h6>{{ $t("chatbotv2.timePeriod") }}</h6>
            <a-select
                :value="cloneFilters.period"
                @select="handleSelectPeriod"
                class="select-story"
                :placeholder="$t('chatbotv2.wholeTimeSpan')"
                :filter-option="false"
            >
                <a-select-option
                    v-for="period of periods"
                    :value="period.value"
                    :key="period.value"
                    @click="() => periodSelectOptionClick(period.value)"
                >
                    <span class="blockTypeText">{{ $t(`chatbotv2.time.${period.value}`) }}</span>
                </a-select-option>
            </a-select>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../utils/log2";
import _ from "lodash";

const log = log2("TrainingFilterTool");
export default {
    name: "TrainingFilterTool",
    components: {},
    data() {
        return {
            /**
             * @type {{period:String,ignored:Boolean,storyId:String,query:String}}
             */
            cloneFilters: _.cloneDeep(this.value),
            periods: [
                { value: "today" },
                { value: "yesterday" },
                { value: "last7" },
                { value: "last30" },
                { value: "this-month" },
                { value: "last-month" },
                { value: "last-3-month" },
                { value: "this-year" },
                { value: "last-year" },
            ],
        };
    },
    props: {
        stories: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => ({
                period: undefined,
                ignored: undefined,
                storyId: undefined,
                query: undefined,
            }),
        },
        rowCount: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        changeIgnoreFilterStatus(filterIgnored) {
            if (filterIgnored) this.cloneFilters.ignored = true;
            else this.cloneFilters.ignored = undefined;
        },
        handleSelectStory(storyId) {
            log("handleSelectStory", storyId);
            this.cloneFilters.storyId = this.cloneFilters.storyId === storyId ? undefined : storyId;
        },
        storySelectOptionClick(storyId) {
            log("storySelectOptionClick", storyId);
            if (this.cloneFilters.storyId === storyId) {
                this.cloneFilters.storyId = undefined;
            }
        },
        handleSelectPeriod(period) {
            log("handleSelectPeriod", period);
            this.cloneFilters.period = this.cloneFilters.period === period ? undefined : period;
        },
        periodSelectOptionClick(period) {
            log("periodSelectOptionClick", period);
            if (this.cloneFilters.period === period) {
                this.cloneFilters.period = undefined;
            }
        },
        handleQueryChange(e) {
            const q = e.target.value.trim();
            log("handleQueryChange", q);
            this.cloneFilters.query = _.isEmpty(q) ? undefined : q;
        },
    },
    mounted() {
        log.info("mounted");
    },
    watch: {
        filters: {
            handler(filters) {
                log("watch filters", filters);
                this.cloneFilters = _.cloneDeep(filters);
            },
            deep: true,
        },
        cloneFilters: {
            handler(filters) {
                log("watch cloneFilters", filters);
                this.$emit("input", filters);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.training-filter-tool {
    background: #22304a;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 25px 35px;
    height: 100%;

    h1 {
        margin-bottom: 15px;
        color: #fff;
        font-weight: 600;
        font-size: 24px;
        line-height: 31px;
        display: flex;
        align-items: center;
    }

    section {
        display: block;
    }

    section.search {
        position: relative;
        width: 100%;

        .material-icons {
            color: #9ba6b3;
            font-size: 20px;
            position: absolute;
            right: 10px;
            top: 10px;
        }

        input {
            background: #354961;
            border: 0;
            border-radius: 6px;
            color: #fff;
            font-size: 15px;
            height: 40px;
            line-height: 19px;
            padding: 0 35px 0 17px;
            width: 100%;
        }
    }

    section.tabs {
        margin-top: 40px;

        .tab {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 25px;
            margin-bottom: 10px;
            transition: all 0.3s;

            .count {
                display: none;
            }

            &.active {
                .material-icons {
                    color: #fff;
                }

                .title {
                    color: #fff;
                    font-weight: 600;
                }

                .count {
                    display: inherit !important;
                }
            }

            .material-icons {
                color: #8aa4be;
                font-size: 21px;
                margin-right: 20px;
                width: 20px;
            }

            .title {
                align-items: center;
                color: #8aa4be;
                display: flex;
                flex-grow: 1;
                font-size: 16px;
                font-weight: 400;
                line-height: 20px;

                .count {
                    background: #008aff;
                    border-radius: 10px;
                    color: #fff;
                    font-size: 12px;
                    line-height: 16px;
                    margin-left: 14px;
                    padding: 3px 8px;
                }
            }
        }
    }

    section.stories,
    section.period {
        margin-top: 40px;

        h6 {
            margin-bottom: 10px;
            color: #fff;
            font-size: 15px;
            line-height: 19px;
        }

        .select-story {
            width: 100%;

            .ant-select-selection {
                background: #354961;
                border-color: #354961;
            }

            .anticon {
                color: black;
            }

            .ant-select-selection-selected-value {
                .blockTypeText {
                    color: black !important;
                }
            }

            &.ant-select-open {
                .blockTypeText {
                    color: #000 !important;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.search-input {
    background: white !important;
    color: black !important;
}
</style>
